import type { GetTerms200AllOfThreeData } from './getTerms200AllOfThreeData';

export type GetTerms200AllOfThree = {
  /** 약관 조회 응답 */
  data?: GetTerms200AllOfThreeData;
};
